import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import Footer from 'components/ModalFaqs/Sections/Footer/container';

export default styled(Footer)`
  padding: 20px ${gridSizes('L')} 12px;
  border-bottom: solid 1px var(--grey-mouse);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  top: calc(100% - 100px);
  width: 100%;
  margin: 0;
  transform: translateY(-100%);
  border-radius: 0 0 1.6rem 1.6rem;
  padding: 16px 24px;
  background-color: var(--primary100);

  .info {
    flex: 1;
    flex-direction: column;
    display: flex;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    h2 {
      margin: 0;
    }
  }

  .close {
    background: none;
    border: none;
    outline: inherit;
    padding: ${gridSizes('S')};
    cursor: pointer;
    display: flex;
    flex-direction: column;

    ${media.lessThan('extraSmall')`
      margin: inherit;
      justify-content: center;
      align-items: center;
      `};
  }

  ${media.lessThan('extraSmall')`
    border-radius: 0px;
    width: 100vw;
    top:  100%;
    padding: 8px;
      `};
`;
